<template>
  <div class="border-top-bottom-semidark bg-white">
    <b-container id="header-menu">
      <div v-if="showLandingMenu" class="pt-3">
        <template v-if="!paymentActive">
          <b-button 
           class="py-1 px-2 f-105"
          :class="showMyReports ? 'fw-600' : ''"
          :variant="showMyReports ? 'bottom-circle' : 'icon-gray'"
          @click="setShowMyReports(true)">나의 보고서</b-button>
          <b-button
            v-if="is_admin === 4"
            class="py-1 px-2 f-105"
            :class="!showMyReports ? 'fw-600' : ''"
            :variant="!showMyReports ? 'bottom-circle' : 'icon-gray'"
            @click="setShowMyReports(false)">즐겨찾기</b-button>
        </template>
        <template v-else>
          <b-button
            class="p-1 mr-3 f-105"
            :class="paymentMenu[0] ? 'fw-600' : ''"
            :variant="paymentMenu[0] ? 'bottom-circle' : 'icon-gray'"
            @click="navigateTo('PaymentService')"
          >
            결제 안내
          </b-button>
          <b-button
            class="p-1 mr-3 f-105"
            :class="paymentMenu[1] ? 'fw-600' : ''"
            :variant="paymentMenu[1] ? 'bottom-circle' : 'icon-gray'"
            @click="navigateTo('UserPaymentCheck')"
          >
            서비스 이용 내역
          </b-button>
          <b-button
            class="p-1 mr-3 f-105"
            :class="paymentMenu[2] ? 'fw-600' : ''"
            :variant="paymentMenu[2] ? 'bottom-circle' : 'icon-gray'"
            @click="navigateTo('ProductPay')"
          >
            추가 서비스 결제
          </b-button>
        </template>
      </div>

      <div v-else class="pt-1 pt-sm-3">
        <template v-if="!selectedReport?.story_board">
          <div class="d-flex">
            <b-button
              class="p-1 mr-3 f-105"
              :class="menuActive[0] ? 'fw-600' : ''"
              :variant="menuActive[0] ? 'bottom-circle' : 'icon-gray'"
              @click="navigateAndReset('BasicSettings')"
            >
              기본설정
            </b-button>
            <b-button
              class="p-1 mr-3 f-105"
              :class="menuActive[1] ? 'fw-600' : ''"
              :variant="menuActive[1] ? 'bottom-circle' : 'icon-gray'"
              @click="goIndicatorSelectorPage"
            >
              지표 선택
            </b-button>
            <b-button
              class="p-1 mr-3 f-105"
              :class="menuActive[2] ? 'fw-600' : ''"
              :variant="menuActive[2] ? 'bottom-circle' : 'icon-gray'"
              @click="goEditorPage"
            >
              보고서 작성
            </b-button>
            <HeaderDropdown />
            <b-button
              class="p-1 mr-3 f-105"
              :class="menuActive[3] ? 'fw-600' : ''"
              :variant="menuActive[3] ? 'bottom-circle' : 'icon-gray'"
              @click="navigateAndReset('CheckReport')"
            >
              검토 및 검증
            </b-button>
            <b-button
              class="p-1 mr-3 f-105"
              :class="menuActive[4] ? 'fw-600' : ''"
              :variant="menuActive[4] ? 'bottom-circle' : 'icon-gray'"
              @click="navigateAndReset('BasicTranslateSet')"
            >
              번역
            </b-button>
          </div>
        </template>

        <template v-else>
          <div class="d-flex responsive-flex">
            <div class="d-flex">
              <b-button
                class="p-1 mr-1 mr-md-2 f-105"
                :class="menuActive[0] ? 'fw-600' : ''"
                :variant="menuActive[0] ? 'bottom-circle' : 'icon-gray'"
                @click="navigateAndReset('BasicSettings')"
              >
                기본설정
              </b-button>
              <HeaderDropdown />
            </div>
            <div class="d-flex">
              <b-button
                class="p-1 f-105"
                @click="navigateAndReset('CheckReport')"
                :active="menuActive[3]"
                :class="menuActive[3] ? 'fw-600' : ''"
                :variant="menuActive[3] ? 'bottom-circle' : 'icon-gray'"
              >
                검토 및 검증
              </b-button>
              <b-button
                class="p-1 f-105 ml-2"
                @click="navigateAndReset('StoryBoardTranslateSet')"
                :active="menuActive[4]"
                :class="menuActive[4] ? 'fw-600' : ''"
                :variant="menuActive[4] ? 'bottom-circle' : 'icon-gray'"
              >
                번역
              </b-button>
            </div>
          </div>
        </template>
      </div>
    </b-container>
  </div>
</template>

<script>
import HeaderDropdown from './HeaderDropdown.vue';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'HeaderMenu',
  components: {
    HeaderDropdown,
  },
  props: {
    showLandingMenu: {
      type: Boolean,
      required: true,
    },
    paymentActive: {
      type: Boolean,
      required: true,
    },
    paymentMenu: {
      type: Array,
      required: true,
    },
    menuActive: {
      type: Array,
      required: true,
    },
    selectedReport: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('reportMenu', ['showMyReports']),
    ...mapState(['is_admin']),
  },
  methods: {
    ...mapActions('reportMenu', ['setShowMyReports']),
    navigateTo(routeName) {
      this.$router.push({ name: routeName });
    },
    navigateAndReset(routeName) {
      this.$router.push({ name: routeName });
      this.$emit('reset');
    },
    goIndicatorSelectorPage() {
      this.$emit('go-indicator-selector-page');
    },
    goEditorPage() {
      this.$emit('go-editor-page');
    },
  },
};
</script>

<style scoped>

    /* 화면 너비가 450px 이하일 때 flex-direction을 column으로 변경 */
    @media (max-width: 450px) {
      .responsive-flex {
        flex-direction: column !important;
        padding-top : 0px !important;
      }
    }
</style>
